
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{staticClass:"i-stroke",attrs:{"d":"M14.039 6H7.462C6.654 6 6 6.654 6 7.462v6.577c0 .807.654 1.461 1.462 1.461h6.577c.807 0 1.461-.654 1.461-1.461V7.462C15.5 6.654 14.846 6 14.039 6"}}),_c('path',{staticClass:"i-stroke_2",attrs:{"d":"M11 3.66v-.698c0-.808-.654-1.462-1.462-1.462H2.962c-.808 0-1.462.654-1.462 1.462v6.576c0 .808.654 1.462 1.462 1.462h.697"}})])])
          )
        }
      }
    